export default __webpack_public_path__ + "static/media/shears-scarecrow.a0fdffc7.jpg";